import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { BASE_URL } from '../constants'

import {
  fetchSuccess,
  fetchStart,
  fetchFailure,
  selectAI,
  deselect
  //prev,
  //next
} from './actions'

import { getAI, getAllAI, getSelected } from './selectors'
import { getVisibleLayerIds } from '../buffers/selectors'

import { useSelectedIncident } from '../incidents/hooks'
import useRecurrantFetch from '../hooks/useRecurrantFetch'

export const useAIFetch = (buffer, layer) => {
  const dispatch = useDispatch()
  const { longitude, latitude } = useSelectedIncident()
  const refreshInterval =
    layer.refreshInterval === 0 ? Infinity : layer.refreshInterval
  const [
    { response, error, isLoading },
    { refresh, cancel }
  ] = useRecurrantFetch(
    `${BASE_URL}api/AI/search`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        aILayerId: buffer.layerId,
        distance: buffer.distance,
        unit: buffer.unit,
        latitude,
        longitude
      }),
      onStart: () => dispatch(fetchStart(buffer.layerId)),
      onSuccess: ai => dispatch(fetchSuccess(buffer.layerId, ai)),
      onError: error => dispatch(fetchFailure(buffer.layerId, error))
    },
    [buffer, layer, latitude, longitude],
    refreshInterval
  )

  return [
    { ai: response, error, isLoading },
    { refresh, cancel }
  ]
}

export const useAI = (layerId, id) => {
  const dispatch = useDispatch()
  const ai = useSelector(getAI)(layerId, id)

  const select = useCallback(() => {
    dispatch(selectAI([id]))
  }, [id, dispatch])

  return [ai, { select }]
}

export const useAIMap = () => {
  const dispatch = useDispatch()
  const ais = useSelector(getAllAI)
  const selected = useSelector(getSelected)
  const visibleLayerIds = useSelector(getVisibleLayerIds)

  const select = useCallback(ids => dispatch(selectAI(ids)), [dispatch])

  const clear = useCallback(() => dispatch(deselect()), [dispatch])

  return [
    { ais, selected, visibleLayerIds },
    { select, clear }
  ]
}
